import { useEffect, useState } from "react";
import { Logo } from "../../components/himt/Primitives";
import { CheckCircle2, Anchor } from "lucide-react";

export default function TestComplete() {
  // Auto-close the tab after 10 seconds to prevent lingering access on shared
  // lab machines. `window.close()` only works for script-opened tabs, so we
  // show a fallback "close this tab manually" message either way.
  const [secondsLeft, setSecondsLeft] = useState(10);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (secondsLeft <= 0) {
      try { window.close(); } catch (e) { /* noop */ }
      setClosed(true);
      return undefined;
    }
    const t = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [secondsLeft]);

  return (
    <div className="min-h-screen bg-white grid place-items-center px-6" data-testid="test-complete-root">
      <div className="max-w-xl w-full text-center">
        <Logo className="justify-center inline-flex" />

        <div className="mt-14 mx-auto h-20 w-20 rounded-sm grid place-items-center bg-green-600 text-white">
          <CheckCircle2 size={40} />
        </div>

        <h1 className="font-display font-black tracking-tighter text-[#0A2540] text-4xl sm:text-5xl mt-8">
          Thanks for submitting your test.
        </h1>
        <p className="text-slate-600 mt-4">
          Your responses have been received.{" "}
          {closed ? (
            <span>Please close this tab manually.</span>
          ) : (
            <span>
              This tab will auto-close in{" "}
              <span className="font-mono font-bold text-[#0A2540]" data-testid="auto-close-counter">
                {secondsLeft}s
              </span>
              .
            </span>
          )}
        </p>

        <div className="mt-14 flex items-center justify-center gap-2 text-xs tracking-[0.25em] uppercase font-bold text-slate-500 font-mono">
          <Anchor size={14} /> HIMT · Video Assessment for Additional Screening
        </div>
      </div>
    </div>
  );
}
